import { useRef, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  IconButton,
  InputAdornment,
  Icon,
  Button,
  CircularProgress,
} from "@material-ui/core";
import FormikField from "../components/FormFields/FormikField";
import { useStateAuthValue } from "../context/AuthState";
import { useNavigate } from "react-router-dom";
import { patientByDni } from "../services/patientsService";
import { useToast } from "../context/Toast/ToastProvider";
import { showToast, ToastType } from "../utils/ToastUtil";
import { loginStyles } from "../styles/makeStyles.js"
import Logo from "../assets/images/logo.png";
import Recaptcha from "../components/Recaptcha";

const formatDate = (dateValue) => {
  if (!dateValue) return "";

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return dateValue;

  return [
    String(date.getUTCDate()).padStart(2, "0"),
    String(date.getUTCMonth() + 1).padStart(2, "0"),
    date.getUTCFullYear(),
  ].join("/");
};

const Socio = () => {
  const classes = loginStyles();
  const navigate = useNavigate();
  const [{}, dispatch] = useStateAuthValue();
  const toastDispatch = useToast();
  const [dni, setDni] = useState(null);
  const recaptchaRef = useRef(null);
   const [data, setData] = useState(null);

  const dniScheme = Yup.object().shape({
    dni: Yup.string()
      .required("DNI Requerido")
  });



  return (
    <div className="login">
      <div className="login__card">
        <aside className="login__brand">
          <img alt="Mediline" className="login__logo" src={Logo} />
          <h1 className="login__brand-title">Backoffice Mediline</h1>
        </aside>

        <div className="login__form">
          <h2 className="login__title">Consulta de estado del socio</h2>
          <p className="login__subtitle">
           Ingrese el DNI para verificar el estado del socio.
          </p>
          <Recaptcha ref={recaptchaRef} />
          <Formik
            initialValues={{
              dni: ""
            }}
            onSubmit={async (values) => {
             
              const recaptchaToken = await recaptchaRef.current?.execute("socio_status");

              if (!recaptchaToken) {
                showToast(
                  toastDispatch,
                  "No se pudo validar reCAPTCHA. Intente nuevamente.",
                  ToastType.ERROR,
                  ToastType.ERROR
                );
                return;
              }
               setDni(values.dni);
               const patientData = await patientByDni({ data: values.dni,  recaptchaToken });
              console.log("Consulta validada con reCAPTCHA", {
                dni: values.dni,
                recaptchaToken,
              });
                console.log("patientData", patientData);
                setData(patientData);
            }}
            validationSchema={dniScheme}
          >
            {({ dirty, isValid, isSubmitting }) => {
              return (
                <Form>
                  <FormikField
                    name="dni"
                    label="DNI"
                    variant="outlined"
                  //  type="number"
                    onKeyDown={(e) => {
                      if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <Button
                    disabled={!(isValid && dirty) || isSubmitting}
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={`${classes.submit} ${
                      isSubmitting ? classes.submitLoading : ""
                    }`}
                    endIcon={
                      isSubmitting ? null : <Icon>chevron_right</Icon>
                    }
                  >
                    {isSubmitting ? (
                      <CircularProgress size={22} thickness={4.5} color="inherit" />
                    ) : (
                      "Verificar"
                    )}
                  </Button>
                </Form>
              );
            }}
          </Formik>
            {data && (
              <div className="socio__data" role="status">
                <div className="socio__dni">
                  <span className="socio__label">DNI consultado</span>
                  <strong>{dni}</strong>
                </div>
                {Object.prototype.hasOwnProperty.call(data, "status") ? (
                  <div
                    className={`socio__status ${
                      !data.status
                        ? "socio__status--inactive"
                        : data.pending_unsubscription_id
                        ? "socio__status--pending"
                        : "socio__status--active"
                    }`}
                  >
                    <span className="socio__label">Estado del socio</span>
                    <strong>
                      {!data.status
                        ? "Inactivo"
                        : data.pending_unsubscription_id
                        ? "Baja en proceso"
                        : "Activo"}
                    </strong>
                    <p>
                      {!data.status
                        ? `Inactivo desde ${formatDate(data.unsubscribe_date)}`
                        : data.pending_unsubscription_id
                        ? `Activo hasta el ${formatDate(
                            data.pending_unsubscription_effective_date
                          )} (período de arrepentimiento)`
                        : `Activo desde ${formatDate(data.created_date)}`}
                    </p>
                    {data.status && <span className="socio__plan">Plan: {data.plan}</span>}
                  </div>
                ) : (
                  <p className="socio__error">{data.error}</p>
                )}
              </div>
            )}

        </div>
      </div>
    </div>
  );
};

export default Socio;
